import { ObjectSchema, Shape } from 'yup'

export const getFormInitialErrors = <T extends Record<string, unknown> = Record<string, unknown>>(
  validationSchema: ObjectSchema<Shape<object | undefined, object>>,
  values: T
): Record<string, string> => {
  try {
    validationSchema.validateSync(values)
  } catch (e) {
    return {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      [e.path]: e.message,
    }
  }

  return {}
}
